import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ContractSignature } from '../../../models/contract/contract-signature';
import { ContractService } from '../../../services/contract/contract.service';

@Component({
    selector: 'app-legal-text-contract-colombia',
    templateUrl: './legal-text-contract-colombia.component.html',
    styleUrls: ['./legal-text-contract-colombia.component.scss'],
    standalone: false
})
export class LegalTextContractColombiaComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  contractSignature: ContractSignature;
  contract: number = 0;
  document: string = '';
  month: string = '';
  country: string = '';
  uuid: string = '';

  constructor(
    private translateService: TranslateService,
    private contractService: ContractService,
    private activatedRoute: ActivatedRoute,
  ) {

    this.contractSignature = new ContractSignature;
  }

  ngOnInit() {

    window.scrollTo(0, 0);

    this.activatedRoute.queryParams.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(params => {

      this.uuid = params.uuid;
      this.contractSummarySearch(this.uuid);
    });

  }

  contractSummarySearch(uuid: string) {

    this.contractService
      .getContractSignature(uuid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: ContractSignature) => {

        this.contractSignature = response;

        if (this.contractSignature.country === 'COL') {
          this.country = 'Colombia'
        }
        const salesDate = new Date(this.contractSignature.salesDate);
        const mes = salesDate.getMonth() + 1;

        switch (mes) {

          case 1:
            this.month = 'enero';
            break;

          case 2:
            this.month = 'fevereiro';
            break;

          case 3:
            this.month = 'marzo';
            break;

          case 4:
            this.month = 'abril';
            break;

          case 5:
            this.month = 'mayo';
            break;

          case 6:
            this.month = 'junio';
            break;

          case 7:
            this.month = 'julio';
            break;

          case 8:
            this.month = 'agosto';
            break;

          case 9:
            this.month = 'septiembre';
            break;

          case 10:
            this.month = 'octubre';
            break;

          case 11:
            this.month = 'noviembre';
            break;

          case 12:
            this.month = 'diciembre';
            break;
        }
      });
  }

}
